
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import Resources from './_resources.mdx';
import Checklist from './_checklist.mdx';
const Layout = require('@/layouts/RootFileLayout').RootFileLayout;
const meta = {
  "title": "Here is the toolkit to develop your Grocery Marketplace Platform",
  "date": "2021-09-03"
};
const slug = 'grocery-marketplace-app';
const tableOfContents = [{
  "title": "Food/Grocery Marketplace",
  "slug": "food-grocery-marketplace",
  "children": []
}, {
  "title": "Listing Categories",
  "slug": "listing-categories",
  "children": []
}, {
  "title": "Listing Attributes",
  "slug": "listing-attributes",
  "children": []
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = require('@/layouts/CustomContentsLayout').CustomContentsLayout
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <p>{`Looking to build a Grocery marketplace, and apps? Here is the toolkit to launch any marketplace without writing a single line of code.`}</p>
    <p>{`Tradly Platform has a simple user interface to build any marketplace like Grocery marketplace and launch your marketplace with our no-code and low code software. It is a complete white label solution…`}</p>
    <p>{`The marketplace can be built on any platform, whether it is Android or iOS. Along with this option, you also get a web app template to get started.`}</p>
    <p>{`Here is an example of how you can configure the catalog, listing fields in your marketplace…`}</p>
    <_Heading level={2} id={"food-grocery-marketplace"} nextElement={{
      "type": "paragraph"
    }}>Food/Grocery Marketplace</_Heading>
    <p><a parentName="p" {...{
        "href": "https://dribbble.com/shots/14831009-Grocery-Shopping-Mobile-App"
      }}><img parentName="a" {...{
          "src": "images/GroceryMarketplace-1.jpg",
          "alt": null
        }}></img></a></p>
    <p>{`Food/Grocery Marketplace - Preview`}</p>
    <_Heading level={2} id={"listing-categories"} nextElement={{
      "type": "table",
      "align": [null, null]
    }}>Listing Categories</_Heading>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Main Categories`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Subcategory`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Beverages`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Coffee`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Tea`}<br parentName="p"></br>{`
`}{`Juice`}<br parentName="p"></br>{`
`}{`Soda`}<br parentName="p"></br>{`
`}{`|
| Bread/Bakery | Sandwich loaves`}<br parentName="p"></br>{`
`}{`Dinner rolls`}<br parentName="p"></br>{`
`}{`Tortillas`}<br parentName="p"></br>{`
`}{`Bagels`}<br parentName="p"></br>{`
`}{`|
| Canned/Jarred Goods | Vegetables`}<br parentName="p"></br>{`
`}{`Spaghetti Sauce`}<br parentName="p"></br>{`
`}{`Ketchup`}<br parentName="p"></br>{`
`}{`|
| Dairy | Cheeses`}<br parentName="p"></br>{`
`}{`Eggs`}<br parentName="p"></br>{`
`}{`Milk`}<br parentName="p"></br>{`
`}{`Yogurt`}<br parentName="p"></br>{`
`}{`Butter`}<br parentName="p"></br>{`
`}{`|
| Dry/Baking Goods | Cereals`}<br parentName="p"></br>{`
`}{`Flour`}<br parentName="p"></br>{`
`}{`Sugar`}<br parentName="p"></br>{`
`}{`Pasta`}<br parentName="p"></br>{`
`}{`Mixes`}<br parentName="p"></br>{`
`}{`|
| Frozen Foods | WafflesVegetables`}<br parentName="p"></br>{`
`}{`Individual Meals`}<br parentName="p"></br>{`
`}{`Ice cream`}<br parentName="p"></br>{`
`}{`|
| Meat | Lunch Meat`}<br parentName="p"></br>{`
`}{`Poultry`}<br parentName="p"></br>{`
`}{`Beef`}<br parentName="p"></br>{`
`}{`|
| Produce | Fruits`}<br parentName="p"></br>{`
`}{`Vegetables`}<br parentName="p"></br>{`
`}{`|
| Cleaners | Laundry Detergent`}<br parentName="p"></br>{`
`}{`Dish-washing Liquid/Detergent`}<br parentName="p"></br>{`
`}{`|
| Paper Goods | Paper Towels`}<br parentName="p"></br>{`
`}{`Toilet Paper`}<br parentName="p"></br>{`
`}{`Aluminum Foil`}<br parentName="p"></br>{`
`}{`Sandwich Bags`}<br parentName="p"></br>{`
`}{`|
| Personal Care | Shampoo`}<br parentName="p"></br>{`
`}{`Soap`}<br parentName="p"></br>{`
`}{`Handsoap`}<br parentName="p"></br>{`
`}{`Shaving Cream`}<br parentName="p"></br>{`
`}{`|
| Other | Baby Items`}<br parentName="p"></br>{`
`}{`Pet Items`}<br parentName="p"></br>{`
`}{`Greeting Cards`}<br parentName="p"></br>{`
`}{`|`}</p>
    <_Heading level={2} id={"listing-attributes"} nextElement={{
      "type": "table",
      "align": [null, null, null, null]
    }}>Listing Attributes</_Heading>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute Groupings`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Attribute`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Example Values`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Applicable for`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`General Attributes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Extra Fast Delivery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$50`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Quantity`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1 kg`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Coupon Code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`FAV10`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Payment Method`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`PayU`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`General Information`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Quality Promise`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Each product has gone through a stringent quality checking process in 3-stages, with a checkpoint of over 50 quality aspects.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Easy Returns`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Not satisfied with a product? Return it to the doorstep & get a refund within hours.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Knowledgebase`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`About Our Service`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`We provide a grocery delivery service across 25 cities in India. Choose from 5000+ products across food, household & other categories.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`All`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Get grocery delivered at the best price`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cheaper prices than your local supermarket, great cashback offers to top it off.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`All`}</td>
        </tr>
      </tbody>
    </table>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`You can charge a commission-based revenue model.`}</li>
    </ul>
    <p>{`For Example, You can charge a certain amount of percentage when each sale is made by the seller…`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`You can collect payment using Stripe, PayU, or Cash on Delivery, etc.`}</li>
      <li parentName="ul">{`You need to decide the delivery method you want to offer in your marketplace very carefully. You can opt for different methods. Learn more about it by `}<a parentName="li" {...{
          "href": "https://tradly.app/docs/delivery"
        }}>{`clicking here`}</a>{`.`}</li>
    </ul>
    <p>{`Looking to build a marketplace? but don’t know how to start… This Video Tutorial will guide you on `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=4fb3yykYXus&list=PLiKQzSFReAziYUvOKfUPxglX-HOhWabVi"
      }}>{`how to build a marketplace`}</a>{`…`}</p>
    <Checklist mdxType="Checklist" />
    <Resources mdxType="Resources" /> 



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
